import { getJurisdiction } from 'pages/jurisdiction'
import { JurisdictionConfig, JurisdictionId } from 'types/jurisdiction/jurisdiction'

const isLocalHost = (): boolean => window.location.host.includes('local')

/** Origin of the OS host app that embedded this preview. */
const embeddingHostApp = (): string => window.location.ancestorOrigins[window.location.ancestorOrigins.length - 1]

/**
 * Single source of truth for jurisdiction-specific behaviour. Anything that
 * differs per jurisdiction belongs here as a config field, never as an inline
 * check at the call site.
 */
export const JURISDICTION_CONFIGS: Record<JurisdictionId, JurisdictionConfig> = {
  CN: {
    defaultLanguage: 'zh',
    resolveHostApp: () => {
      if (isLocalHost()) return 'https://local.apps.dev.wppopen.cn'

      // In CN the host app is reached through dynamic tenant prefixes, so it
      // passes its own origin in the URL; use that directly when present.
      const hostParam = new URLSearchParams(window.location.search).get('host')
      if (hostParam) return hostParam

      return embeddingHostApp()
    },
  },
  DEFAULT: {
    defaultLanguage: 'en',
    resolveHostApp: () => {
      if (isLocalHost()) return 'https://local.apps.wpp-stage.os-dev.io'

      return embeddingHostApp()
    },
  },
}

/** Resolved config for the active jurisdiction. Prefer this over ad-hoc checks. */
export const jurisdictionConfig = (): JurisdictionConfig => JURISDICTION_CONFIGS[getJurisdiction()]

/** Origin of the host app the theme builder preview is embedded in. */
export const getThemeBuilderHostApp = (): string => jurisdictionConfig().resolveHostApp()
